import { defineMiniApp } from '../../registry';

import { FindingsReviewPanel } from './FindingsReviewPanel';
import { CLINICAL_FINDINGS_AGENT_ID } from './constants';
import { useFindingsActionState } from './useFindingsActionState';

/**
 * Clinical-findings mini-app: extracts coded findings (diagnoses, exam findings,
 * goals) from the session note + transcript for human review. Extraction runs
 * automatically on appointment completion (api-nest `extract_clinical_resources`
 * task → the agent), so this surface is review-only — there is no manual
 * "extract" trigger / consent screen. Self-contained: the appointment-session
 * page only renders `<MiniAppActions slot=… />`.
 */
export const clinicalFindingsApp = defineMiniApp({
  id: CLINICAL_FINDINGS_AGENT_ID,
  identity: {
    displayName: 'Clinical Findings',
    publisher: 'Eluve',
    trustLevel: 'first-party',
  },
  slots: ['appointment-session'],
  review: {
    label: 'Review findings',
    visible: (ctx) => Boolean(ctx.appointmentId),
    surface: 'sidepanel',
    component: FindingsReviewPanel,
  },
  useActionState: useFindingsActionState,
});
